module.exports = __webpack_public_path__ + "img/19800.e60bb7ab.jpg";